import { ParamIds, Places } from 'src/Constants'
import BorderoKeys from '../bordero.keys'
import { ShowResultadoDetalhado } from '../bordero.types'

const resultadoDetalhadoShowKey = 'rdsk_k'

export class ResultadoDetalhadoAnaliseKeys extends BorderoKeys {
    get place() {
        return Places.mcResultadoDetalhadoAnalise
    }

    get borderoId() {
        return this._intent.getParameterAsNumber(ParamIds.mcBorderoFormId)
    }

    set borderoId(value: number | undefined) {
        this._intent.setParameter(ParamIds.mcBorderoFormId, value)
    }

    get resultadoShowOrigem() {
        return this._intent.getParameterAsString(ParamIds.mcResultadoShowOrigem)
    }

    set resultadoShowOrigem(value: string | undefined) {
        this._intent.setParameter(ParamIds.mcResultadoShowOrigem, value)
    }

    get resultadoShowIdOrigem() {
        return this._intent.getParameterAsNumber(ParamIds.mcResultadoShowIdOrigem)
    }

    set resultadoShowIdOrigem(value: number | undefined) {
        this._intent.setParameter(ParamIds.mcResultadoShowIdOrigem, value)
    }

    get resultadoShowIdSacado() {
        return this._intent.getParameterAsNumber(ParamIds.mcResultadoShowIdSacado)
    }

    set resultadoShowIdSacado(value: number | undefined) {
        this._intent.setParameter(ParamIds.mcResultadoShowIdSacado, value)
    }

    get resultadoDetalhadoShow() {
        return this._intent.attributes.get(resultadoDetalhadoShowKey) as ShowResultadoDetalhado
    }

    set resultadoDetalhadoShow(value: ShowResultadoDetalhado | undefined) {
        this._intent.attributes.set(resultadoDetalhadoShowKey, value)
    }
}
